import { Routes, Route } from 'react-router-dom';
import { PayrollDashboardPage } from './payroll-dashboard-page';
import { ExpensesListPage } from './expenses/expenses-list-page';
import { CreateExpensePage } from './expenses/create-expense-page';
import { ExpenseDetailPage } from './expenses/expense-detail-page';
import { MileagePage } from './mileage/mileage-page';
import { PerDiemPage } from './per-diem/per-diem-page';
import { MyExpensesPage } from './my-expenses-page';
import { TimesheetsListPage } from './timesheets/timesheets-list-page';
import { TimesheetDetailPage } from './timesheets/timesheet-detail-page';
import { JobCostingListPage } from './job-costing/job-costing-list-page';
import { JobCostingDetailPage } from './job-costing/job-costing-detail-page';
import { PayrollRunsListPage } from './runs/payroll-runs-list-page';
import { NewPayrollRunPage } from './runs/new-payroll-run-page';
import { PayrollRunDetailPage } from './runs/payroll-run-detail-page';
import { PayRatesPage } from './rates/pay-rates-page';
import { PayrollSettingsPage } from './settings/payroll-settings-page';
import { CostCodesPage } from './cost-codes/cost-codes-page';
import { ReportsPage } from './reports/reports-page';
import { QuickBooksSettingsPage } from './quickbooks/quickbooks-settings-page';
import { ExpensePoliciesPage } from './policies/expense-policies-page';
import { RecurringExpensesPage } from './recurring/recurring-expenses-page';
import { MobileExpenseCapturePage } from './mobile-capture/mobile-expense-capture-page';
import { ReconciliationPage } from './reconciliation/reconciliation-page';
import { DelegationsPage } from './delegations/delegations-page';

export function PayrollPage() {
  return (
    <Routes>
      <Route index element={<PayrollDashboardPage />} />
      <Route path="expenses" element={<ExpensesListPage />} />
      <Route path="expenses/new" element={<CreateExpensePage />} />
      <Route path="expenses/:id" element={<ExpenseDetailPage />} />
      <Route path="mileage" element={<MileagePage />} />
      <Route path="per-diem" element={<PerDiemPage />} />
      <Route path="my-expenses" element={<MyExpensesPage />} />
      <Route path="timesheets" element={<TimesheetsListPage />} />
      <Route path="timesheets/:id" element={<TimesheetDetailPage />} />
      <Route path="job-costing" element={<JobCostingListPage />} />
      <Route path="job-costing/:projectId" element={<JobCostingDetailPage />} />
      <Route path="runs" element={<PayrollRunsListPage />} />
      <Route path="runs/new" element={<NewPayrollRunPage />} />
      <Route path="runs/:id" element={<PayrollRunDetailPage />} />
      <Route path="rates" element={<PayRatesPage />} />
      <Route path="settings" element={<PayrollSettingsPage />} />
      <Route path="cost-codes" element={<CostCodesPage />} />
      <Route path="reports" element={<ReportsPage />} />
      {/* Session 5.6: H3Pay Enhancements */}
      <Route path="quickbooks" element={<QuickBooksSettingsPage />} />
      <Route path="policies" element={<ExpensePoliciesPage />} />
      <Route path="recurring" element={<RecurringExpensesPage />} />
      <Route path="mobile-capture" element={<MobileExpenseCapturePage />} />
      {/* S17: PM Hours Reconciliation */}
      <Route path="reconciliation" element={<ReconciliationPage />} />
      {/* S10: Approval Delegation */}
      <Route path="delegations" element={<DelegationsPage />} />
    </Routes>
  );
}
